module.exports = __webpack_public_path__ + "static/media/ballade-siecle.05136522.jpg";